module.exports = __webpack_public_path__ + "media/images/special-reports@2x-d477c835a223da95acfb93ff6c7d03ac.png";